<template>
	<div v-bind="$attrs" :style="dynamicStyles">
		<transition name="fade">
			<img
				v-show="loaded"
				:src="image"
				:style="imageStyle"
				style="width: 100%"
				alt=""
				@load="loaded=true"
			>
		</transition>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

// Props
const props = defineProps({
	image: {
		type: String,
		required: true
	},
	heightProportion: {
		type: Number,
		default: 100
	}
})

// Reactives
const loaded = ref(false)

// Computeds
const imageStyle = computed(() => (props.heightProportion && props.heightProportion != 100) ? "object-fit: cover; position: absolute; top: 0; left: 0; height: 100%;" : "")
const dynamicStyles = computed(() => {
	// Calculate the proportion if provided
	if(props.heightProportion && props.heightProportion != 100){
		return {
			// use const assertion so TS infers the specific position literal type
			position: 'relative' as const,
			paddingTop: props.heightProportion + "%"
		}
	}

	// return undefined instead of null to match expected optional style
	return undefined
})
</script>